import { RemovePickupDeliveryAddressModal } from '@/types/modal';
import { useTranslation } from 'react-i18next';
import { useOrder, useRemovePickupDeliveryAddress } from '@/hooks/order';
import React, { useEffect } from 'react';
import { ErrorModal, LoadingBodyModal, StandardModal, SuccessModal } from '@/components/molecules/common/Modal';
import styles from './Modal.module.scss';

const View: React.FC<{ modal: RemovePickupDeliveryAddressModal }> = ({ modal }) => {
  const { t } = useTranslation();
  const { order, onClose } = modal;
  const orderR = useOrder(Number(order.orderId), false);
  const submitR = useRemovePickupDeliveryAddress(Number(order.orderId));
  useEffect(() => {
    if (submitR.kind === 'Completed') {
      orderR.refetch();
    }
  }, [submitR.kind]);

  if (submitR.kind === 'Error') {
    return (
      <ErrorModal
        title={t('modal.remove_pickup_delivery_address.title')}
        error={submitR.error}
        onClose={onClose}
      />
    );
  } else if (submitR.kind === 'Completed') {
    return (
      <SuccessModal
        title={t('modal.remove_pickup_delivery_address.title')}
        onClose={onClose}
      />
    );
  }

  const body =
    submitR.kind === 'Loading' ? (
      <LoadingBodyModal height={40} />
    ) : (
      <div className={styles.flex100}>
        <div className={styles.height1rem} />
        <div className={styles.text1rem}>{`${t('modal.remove_pickup_delivery_address.order')} #${order.orderId}`}</div>
        <div className={styles.height1rem} />
        <div className={styles.text1rem}>{t('modal.remove_pickup_delivery_address.body')} </div>
      </div>
    );

  return (
    <StandardModal
      title={t('modal.remove_pickup_delivery_address.title')}
      onClose={onClose}
      onSubmit={submitR.mutate}
      closeLabel={t('common.no').toUpperCase()}
      submitLabel={t('common.yes').toUpperCase()}
      submittable={submitR.kind !== 'Loading'}
      body={body}
      containerStyle={{ width: 550 }}
      modalName="remove_pickup_delivery_address"
    />
  );
};

export default View;
